export default "assets/images/simple-text-texture-4ac2c142.png";